import { ValidationRuleMatch }            from '@cs/components/util';
import { DataGridAction }                 from './data-grid-action';
import { DataGridCellType, GridItemType } from '../enums/data-grid.enum';
import { GridActions }                    from '../enums/data-grid.enum';

import { isNullOrUndefined } from '@cs/core';

export class DataGridValidatorAction implements DataGridAction {
	readonly type: GridActions = GridActions.AddValidator;

	/**
		* Scope to which to limit the match (e.g. row of the cell)
		*/
	matchScope: GridItemType = GridItemType.Cell;

	/**
		* Filter by cell type (default: Data).
		*/
	celltype: DataGridCellType = DataGridCellType.Data;

	/**
		* LevelKeys or factProperties to Match on (see LevelKeys for more info)
		*/
	match: ValidationRuleMatch;

	// target: GridItemType.Cell; // fixed property, only validated against cell values
	/**
		* Message for display purposes
		*/
	errorMessage: string;

	/**
		* Kind of validation. 'match' (default) validates against the match object.
		* 'sanityRange' warns (with user confirmation) when an entered value is outside
		* [min, max]; when min/max are omitted the range is derived client-side from the
		* values currently in the same column ([columnMax / factor, columnMax * factor]).
		*/
	validatorType: 'match' | 'sanityRange' = 'match';

	/**
		* Explicit lower bound for sanityRange validation (optional)
		*/
	min: number = null;

	/**
		* Explicit upper bound for sanityRange validation (optional)
		*/
	max: number = null;

	/**
		* Multiplier used to derive the sanity range from the current dataset
		* when no explicit min/max are provided
		*/
	factor = 10;

	/**
		* Message shown in the confirmation dialog when a sanityRange validation trips.
		* Supports {value} and {limit} placeholders.
		*/
	confirmMessage: string = null;

	constructor(initial: Partial<DataGridValidatorAction> = null) {
		if (!isNullOrUndefined(initial))
			Object.assign(this, initial);
	}
}
